import { config } from '@iheartjane/config';

import { api } from '@jane/shared/data-access';
import type { BannerMessageSetting } from '@jane/shared/types';

const bannerMessageSettingUrl = (storeId: number) =>
  `${config.apiPath}/stores/${storeId}/banner_message_settings`;

const getStoreBannerMessageSettings = async (id: number) => {
  return api.get<BannerMessageSetting | null>(bannerMessageSettingUrl(id));
};

export const storeBannerMessageSettingsQueryBody = (storeId: number) => ({
  queryFn: () => getStoreBannerMessageSettings(storeId),
  queryKey: ['banner_message_settings', storeId],
});
